(function () {
  function init(wrap) {
    if (wrap.__lt) return; wrap.__lt = true;
    var section = wrap.closest('.lt-revs');
    var t = wrap.querySelector('[data-rev-track]');
    var prev = section.querySelector('[data-rev-prev]');
    var next = section.querySelector('[data-rev-next]');
    var thumb = section.querySelector('[data-rev-thumb]');
    var el = wrap.querySelector('[data-edge-l]');
    var er = wrap.querySelector('[data-edge-r]');
    function step() { var c = t.querySelector('.lt-rev-card'); return (c ? c.offsetWidth : 300) + 16; }
    function sync() {
      var max = t.scrollWidth - t.clientWidth;
      var w = t.scrollWidth > 0 ? Math.min(100, t.clientWidth / t.scrollWidth * 100) : 100;
      var left = max > 1 ? t.scrollLeft / max * (100 - w) : 0;
      if (thumb) { thumb.style.width = w + '%'; thumb.style.left = left + '%'; }
      var atStart = t.scrollLeft <= 1, atEnd = t.scrollLeft >= max - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (el) el.classList.toggle('is-off', atStart);
      if (er) er.classList.toggle('is-off', atEnd);
    }
    if (prev) prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
    t.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // drag to scroll with a mouse
    var d = null;
    t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; d = { x: e.clientX, left: t.scrollLeft }; t.classList.add('is-drag'); try { t.setPointerCapture(e.pointerId); } catch (er2) {} });
    t.addEventListener('pointermove', function (e) { if (d) t.scrollLeft = d.left - (e.clientX - d.x); });
    function up() { if (!d) return; d = null; t.classList.remove('is-drag'); var by = step(); t.scrollTo({ left: Math.round(t.scrollLeft / by) * by, behavior: 'smooth' }); }
    t.addEventListener('pointerup', up); t.addEventListener('pointercancel', up);
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); t.scrollBy({ left: step(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); t.scrollBy({ left: -step(), behavior: 'smooth' }); }
    });
    sync();
  }
  function boot() { document.querySelectorAll('[data-rev]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
